module.exports = __webpack_public_path__ + "img/icon_NCDs_A03_bf.55c7c427.png";